import { Tabs, TabsProps } from 'antd';

import { getFromLocalStorage, writeToLocalState } from "utils/localStorage";
import { ComplexPrograms } from "pages/Recommendations/containers/ComplexPrograms";
import { WeRecommend } from "pages/Recommendations/containers/WeRecommend";
import { Offers } from "pages/Recommendations/containers/Offers";

type TabItem = Required<TabsProps>['items'][number]

const items: TabItem[] = [
  {
    key: 'recommend',
    label: 'Мы рекомендуем',
    children: <WeRecommend />,
  },
  {
    key: 'complex',
    label: 'Комплексные программы для вас',
    children: <ComplexPrograms />,
  },
  {
    key: 'offers',
    label: 'Акции и предложения',
    children: <Offers />,
  },
]

const LOCAL_STORAGE_KEY = 'recommendationsTab'

const Recommendations = () => {
  const handleChangeTab = (selectedTab: string) => {
    writeToLocalState(LOCAL_STORAGE_KEY, selectedTab)
  }
  return(
    <>
      <Tabs
        defaultActiveKey={getFromLocalStorage(LOCAL_STORAGE_KEY)}
        onChange={handleChangeTab}
        items={items}
        type="line"
      />
    </>
  )
}

export default Recommendations;